// Small helpers to read/write deeply-nested values by dot path (e.g. "hero.line1").
export const deepClone = (obj) => JSON.parse(JSON.stringify(obj ?? {}));

export function getByPath(obj, path) {
  return path.split(".").reduce((acc, key) => (acc == null ? acc : acc[key]), obj);
}

export function setByPath(obj, path, value) {
  const keys = path.split(".");
  const clone = deepClone(obj);
  let cur = clone;
  for (let i = 0; i < keys.length - 1; i += 1) {
    const k = keys[i];
    if (cur[k] == null) cur[k] = {};
    cur = cur[k];
  }
  cur[keys[keys.length - 1]] = value;
  return clone;
}
